import React from 'react'

const Communication = () => {
  return (
    <div>Communication</div>
  )
}

export default Communication